import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DEFAULT_PRODUCT from 'Images/default_product.png';

const LinkedProductAction = ({ linkedProduct = {}, unlinkProduct }) => {
  const image = React.createRef();

  if (!linkedProduct.reference) {
    return null;
  }

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'space-between',
      background: '#FFFFFF 0% 0% no-repeat padding-box',
      boxShadow: '0px 12px 26px #0000000D',
      borderRadius: 1.5,
      padding: 3,
    }}
    >
      <Box sx={{ display: 'flex' }}>
        <img
          ref={image}
                // eslint-disable-next-line no-return-assign
          onError={() => (image.current.src = DEFAULT_PRODUCT)}
          style={{ height: 71 }}
          src={`https://media.copima.ma/products/${linkedProduct?.img || linkedProduct?.image}`}
          alt={linkedProduct?.reference}
        />
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          pl: 1,
        }}
        >
          <Typography sx={{
            font: 'normal normal 600 14px Montserrat',
            color: '#007BC6',
          }}
          >
            {`RÉF: ${linkedProduct.reference}`}
          </Typography>
          <Typography sx={{ font: 'normal normal medium 18px Montserrat' }}>
            {linkedProduct.des}
          </Typography>
        </Box>
      </Box>
      <IconButton
        onClick={unlinkProduct}
        style={{
          background: '#F86060',
          borderRadius: 12,
          padding: 8,
          color: '#FFF',
          marginTop: 'auto',
          marginBottom: 'auto',
        }}
        size="large"
      >
        <DeleteOutlineOutlinedIcon />
      </IconButton>
    </Box>
  );
};

export default LinkedProductAction;
